export default __webpack_public_path__ + "static/media/Image.e631d672.png";